export const Experiment = {
    template: `
        <ng-transclude></ng-transclude>
    `,
    bindings: {
        splitName: '@',
        attributes: '<?'
    },
    require: {
        abTest: '^abTest'
    },
    transclude: true,
    controller: class {
        constructor($scope) {
            'ngInject';
            this.$scope = $scope;
        }

        async $onInit() {
            this.treatments = [];
            const client = await this.abTest.client;
            if (client) {
                client.on(client.Event.SDK_UPDATE, () => this.getAndSelectTreatment());
            }
        }

        $postLink() {
            return this.getAndSelectTreatment();
        }

        async getAndSelectTreatment() {
            const treatment = await this.abTest.getTreatment(this.splitName, this.attributes);
            this.selectTreatment(treatment);
        }

        selectTreatment(treatmentKey = 'default') {
            this.$scope.$apply(() => {
                const isTreatmentMatch = t => t.treatmentKey === treatmentKey;
                const isDefault = t => !!t.default;
                const shouldBeSelected = treatmentKey === 'default' ? isDefault : isTreatmentMatch;

                this.treatments.forEach(treatment => {
                    treatment.selected = shouldBeSelected(treatment);
                });
            });
        }

        addTreatment(treatment) {
            this.treatments.push(treatment);
        }
    }
};
